export var MuiFormHelperText = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        marginLeft: 0,
        marginTop: theme.spacing(theme.spaces.main),
        fontSize: theme.typography.body2.fontSize,
        "&.Mui-error": {
          fontWeight: 600
        }
      };
    }
  }
};
//# sourceMappingURL=MuiFormHelperText.js.map